import {
  SUPERADMIN_ALL_ACTIVE_VENDORS,
  SUPERADMIN_ALL_PENDING_VENDORS,
  SET_SELECT_DATE_RANGE,
  SUPERADMIN_VENDORS_SINGLE_REVIEW,
  SUPERADMIN_VENDORS_OPEN_ISSUES,
  SUPERADMIN_SINGLE_VENDORS_OPEN_ISSUES,
  SUPERADMIN_ONBOARDING_REDUCERS,
  SUPERADMIN_ONBOARDING_SUCCESS,
  SUPERADMIN_VENDOR_SEATING_DINER,
  SUPERADMIN_VENDOR_PENDING_DINER,
  SUPERADMIN_VENDOR_RESERVATION_DINER,
  SUPERADMIN_VENDOR_HISTORY_DINER,
  SET_VENDOR_INFORMATION,
  SET_MERCHANT_EDIT_INFO,
  SET_MERCHANT_EDIT_ACTION_TYPE,
  SUPERADMIN_GET_ALL_DINER_ID,
  FILTER_DATE_VALUE,
} from "../../types";

const initialState = {
  superAdminAllActiveVendors: [],
  superAdminAllPendingVendors: [],
  set_select_date_range: {},
  superAdminSingleReview: [],
  superAdminOpenIssuesVendor: [],
  superAdminOnboardingReducers: [],
  superAdminGetSeatingVendorDiner: [],
  superAdminGetPendingVendorDiner: [],
  superAdminGetReservationVendorDiner: [],
  superAdminGetHistoryVendorDiner: [],
  superAdminVendorInfo: {},
  superAdminMerchantEditInfo: {},
  superAdminMerchantEditType: {
    editData: false,
  },
  superAdminDinersInfo: {},
  superAdminSingleOpenIssuesVendor: {},
  filter_date_value: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SUPERADMIN_ALL_ACTIVE_VENDORS:
      return {
        ...state,
        superAdminAllActiveVendors: action.payload,
      };
    case SUPERADMIN_ALL_PENDING_VENDORS:
      return {
        ...state,
        superAdminAllPendingVendors: action.payload,
      };
    case SET_SELECT_DATE_RANGE:
      return {
        ...state,
        set_select_date_range: action.payload,
      };
    case SUPERADMIN_VENDORS_SINGLE_REVIEW:
      return {
        ...state,
        superAdminSingleReview: action.payload,
      };
    case SUPERADMIN_VENDORS_OPEN_ISSUES:
      return {
        ...state,
        superAdminOpenIssuesVendor: action.payload,
      };
    case SUPERADMIN_SINGLE_VENDORS_OPEN_ISSUES:
      return {
        ...state,
        superAdminSingleOpenIssuesVendor: action.payload,
      };
    case SUPERADMIN_ONBOARDING_REDUCERS:
      return {
        ...state,
        superAdminOnboardingReducers: action.payload,
      };
    case SUPERADMIN_ONBOARDING_SUCCESS:
      return {
        ...state,
        superAdminOnboardingReducers: [],
      };
    case SUPERADMIN_VENDOR_SEATING_DINER:
      return {
        ...state,
        superAdminGetSeatingVendorDiner: action.payload,
      };
    case SUPERADMIN_VENDOR_PENDING_DINER:
      return {
        ...state,
        superAdminGetPendingVendorDiner: action.payload,
      };
    case SUPERADMIN_VENDOR_RESERVATION_DINER:
      return {
        ...state,
        superAdminGetReservationVendorDiner: action.payload,
      };
    case SUPERADMIN_VENDOR_HISTORY_DINER:
      return {
        ...state,
        superAdminGetHistoryVendorDiner: action.payload,
      };
    case SET_VENDOR_INFORMATION:
      return {
        ...state,
        superAdminVendorInfo: action.payload,
      };
    case SET_MERCHANT_EDIT_INFO:
      return {
        ...state,
        superAdminMerchantEditInfo: action.payload,
      };
    case SET_MERCHANT_EDIT_ACTION_TYPE:
      return {
        ...state,
        superAdminMerchantEditType: {
          editData: action.payload,
        },
      };
    case SUPERADMIN_GET_ALL_DINER_ID:
      return {
        ...state,
        superAdminDinersInfo: action.payload,
      };
    case FILTER_DATE_VALUE:
      return {
        ...state,
        filter_date_value: action.payload,
      };
    default:
      return state;
  }
}
